import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import {NavigationComponent} from "./navigation.component";
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';


@NgModule({
    declarations: [NavigationComponent],
    imports     : [BrowserModule, RouterModule, BsDropdownModule],
    exports     : [NavigationComponent],
})

export class NavigationModule {
   
    constructor(){
        
    }
}